import { AppState } from '../../types'
import { Dashboard } from './model'

const getAll = (state: AppState): Dashboard => state.monitoring.dashboard;

export const getTitle = (state: AppState) => getAll(state).title;

export const isStarred = (state: AppState) => getAll(state).isStarred;
